const FeaturesSection = ({ onOpenDemo }) => {
    return (
        <section id="features" className="py-20 bg-white">
            <div className="container mx-auto px-4">
                <div className="text-center mb-14">
                    <span className="text-blue-600 font-semibold text-sm uppercase tracking-widest">What You Get</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2">
                        Everything You Need to Protect Your Margins
                    </h2>
                    <p className="text-gray-500 mt-3 max-w-2xl mx-auto">
                        One platform. Web dashboard + mobile app. No extra kit required.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

                    <div className="feature-card bg-gray-50 p-7 rounded-2xl shadow-sm cursor-default">
                        <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-5">
                            <i className="fas fa-clipboard-check text-blue-600 text-2xl"></i>
                        </div>
                        <h3 className="text-lg font-bold text-gray-800 mb-2">Delivery Note Verification</h3>
                        <p className="text-gray-500 text-sm mb-4">
                            Automatically cross-reference every scanned part with your uploaded delivery notes — discrepancies flagged instantly.
                        </p>
                        <span className="text-green-600 text-xs font-semibold">
                            <i className="fas fa-arrow-trend-up mr-1"></i>Reduce disputes &amp; returns
                        </span>
                    </div>

                    <div className="feature-card bg-gray-50 p-7 rounded-2xl shadow-sm cursor-default">
                        <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-5">
                            <i className="fas fa-brain text-purple-600 text-2xl"></i>
                        </div>
                        <h3 className="text-lg font-bold text-gray-800 mb-2">AI Part Recognition</h3>
                        <p className="text-gray-500 text-sm mb-4">
                            No barcode? No problem. Our computer-vision AI identifies parts by appearance, so nothing slips through unverified.
                        </p>
                        <span className="text-green-600 text-xs font-semibold">
                            <i className="fas fa-arrow-trend-up mr-1"></i>100% of parts covered
                        </span>
                    </div>

                    <div className="feature-card bg-gray-50 p-7 rounded-2xl shadow-sm cursor-default">
                        <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center mb-5">
                            <i className="fas fa-barcode text-amber-600 text-2xl"></i>
                        </div>
                        <h3 className="text-lg font-bold text-gray-800 mb-2">Instant Barcode Scanning</h3>
                        <p className="text-gray-500 text-sm mb-4">
                            Use your smartphone camera as a professional scanner — no expensive hardware, no extra training.
                        </p>
                        <span className="text-green-600 text-xs font-semibold">
                            <i className="fas fa-arrow-trend-up mr-1"></i>Save on equipment costs
                        </span>
                    </div>

                    <div className="feature-card bg-gray-50 p-7 rounded-2xl shadow-sm cursor-default">
                        <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center mb-5">
                            <i className="fas fa-chart-line text-green-600 text-2xl"></i>
                        </div>
                        <h3 className="text-lg font-bold text-gray-800 mb-2">Audit-Ready Reports</h3>
                        <p className="text-gray-500 text-sm mb-4">
                            One-click PDF reports per scanning session — perfect for supplier disputes, insurance claims, and internal audits.
                        </p>
                        <span className="text-green-600 text-xs font-semibold">
                            <i className="fas fa-arrow-trend-up mr-1"></i>Settle disputes faster
                        </span>
                    </div>

                </div>

                <div className="text-center mt-14">
                    <button
                        onClick={onOpenDemo}
                        className="cta-amber text-white px-8 py-4 rounded-xl font-bold text-base shadow-lg hover:shadow-xl transition"
                    >
                        <i className="fas fa-calendar-check mr-2"></i> See All Features in a Live Demo
                    </button>
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;
